"use strict";

jQuery(document).on("custom_DKT_libraries_loaded", function() {
  DKTFavorites.init();
  DKTMap.init();
  DKTPaths.initSpecialPage();

  var selectedTamborradaData = DKTPaths.getSelectedTamborradaData();
  if (selectedTamborradaData && selectedTamborradaData.length > 0) {
    if (DKTFavorites.isFavorite(selectedTamborradaData[0].id)) {
      DKTFavorites.turnOnFavoriteButtons();
    } else {
      DKTFavorites.turnOffFavoriteButtons();
    }
    DKTMap.drawPaths(selectedTamborradaData);
    DKTMap.drawStartingPoints(selectedTamborradaData);
    DKTMap.zoomToSelectedTamborrada();
    DKTPaths.colorizeHours(selectedTamborradaData[0]);
  }    
});